import type { Decorator } from 'final-form'
import type { FormProps } from 'react-final-form'
import { Form } from 'react-final-form'

import { focusOnErrors } from '@helpers'

/**
 * Wrapper component over react-final-form to apply focusOnErrors decorator as a default decorator
 */
export default function ReactFinalForm<FormValues = Record<string, unknown>>({
  decorators,
  ...restProps
}: FormProps<FormValues>) {
  return (
    <Form
      // casting is required otherwise will error out
      decorators={[focusOnErrors as Decorator<FormValues, Partial<FormValues>>].concat(decorators || [])}
      {...restProps}
    />
  )
}
